import { RegisterAccountGroupsShareApi } from "@/features/accounts/account-group/services/register-account-groups-share-api";
import { RegisterAccountGroupsShareRequestModel } from "@/features/accounts/account-group/services/register-account-groups-share-model";

/// 口座グループ共有メンバー登録
export class RegisterAccountGroupsShareService {
  private registerAccountGroupsShareApi = new RegisterAccountGroupsShareApi();

  /**
   * 口座グループ共有メンバー登録
   */
  public async registerAccountGroupsShare(param: RegisterAccountGroupsShareRequestModel) {
    return await this.registerAccountGroupsShareApi.registerAccountGroupsShare(param);
  }
}

